export const BUNITO_REQUEST = "BUNITO_REQUEST";
export const BUNITO_SUCCESS = "BUNITO_SUCCESS";
export const BUNITO_FAILED = "BUNITO_FAILED";
